/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Approved_DescriptionInputs */

const en_orders_review_approved_description = /** @type {(inputs: Orders_Review_Approved_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pictures are reviewed and the order can move forward.`)
};

const es_orders_review_approved_description = /** @type {(inputs: Orders_Review_Approved_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fotos estan revisadas y el pedido puede avanzar.`)
};

/**
* | output |
* | --- |
* | "Pictures are reviewed and the order can move forward." |
*
* @param {Orders_Review_Approved_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_approved_description = /** @type {((inputs?: Orders_Review_Approved_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Approved_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_approved_description(inputs)
	return es_orders_review_approved_description(inputs)
});